// extracted by mini-css-extract-plugin
module.exports = {"grey4":"#C6C6C6","bottomLine":"styles_bottomLine__10YJM","bottomLineLonger":"styles_bottomLineLonger__35YBd","text":"styles_text__PJuX_","text2":"styles_text2__2Zign"};